//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
//================= [VUE COMPONENTS] ==========================

export const commonRoutes = [
  {
    path: '/:pathMatch(.*)*',
    name: Routes.NOT_FOUND,
    // NotFound kommt aus der Paketwurzel, nicht aus src/ von client-core: die
    // exports-Map dort gibt nur die Wurzel und ./i18n/* frei (T00CT37WBOWH).
    component: () => import('@simpleforyou/client-core').then(module => module.NotFound),
    meta: {
      layout: 'clean',
      noAuthRequired: true,
    },
  },
  {
    path: i18n.global.t('routes.base'),
    redirect: i18n.global.t('routes.login'),
  },
  {
    path: i18n.global.t('routes.login'),
    name: Routes.LOGIN,
    component: () => import('@/components/SignIn.vue'),
    meta: {
      noAuthRequired: true,
      layout: 'clean',
      title: i18n.global.t('titles.login'),
    },
  },
  {
    // OIDC — fixer, sprachunabhängiger Landepunkt des Login-Redirects. Der Pfad
    // muss exakt der API-seitigen redirect_uri (oidcConfig.OIDC_REDIRECT_PATH)
    // entsprechen; die API validiert das Origin-Suffix (*.community-coaching.com).
    path: '/oauth/callback',
    name: Routes.OIDC_CALLBACK,
    component: () => import('@/components/auth/OidcCallback.vue'),
    meta: {
      noAuthRequired: true,
      layout: 'clean',
      title: i18n.global.t('titles.login'),
    },
  },
  {
    path: i18n.global.t('routes.passwordForgot'),
    name: Routes.PASSWORD_FORGOT,
    component: () => import('@/components/PasswordForgot.vue'),
    meta: {
      noAuthRequired: true,
      layout: 'clean',
      title: i18n.global.t('titles.passwordForgot'),
    },
  },
  {
    path: i18n.global.t('routes.passwordForgotConfirm'),
    name: Routes.PASSWORD_FORGOT_CONFIRM,
    component: () => import('@/components/PasswordForgotConfirm.vue'),
    meta: {
      noAuthRequired: true,
      layout: 'clean',
      title: i18n.global.t('titles.passwordForgotConfirm'),
    },
  },
  {
    path: i18n.global.t('routes.password'),
    name: Routes.PASSWORD,
    component: () => import('@/components/SetPassword.vue'),
    meta: {
      layout: 'clean',
      title: i18n.global.t('titles.password'),
    },
  },
  {
    path: i18n.global.t('routes.coaching'),
    name: Routes.COACHING,
    component: () => import('@/components/CoachingApproval.vue'),
    meta: {
      noAuthRequired: true,
      layout: 'clean',
      title: i18n.global.t('titles.coaching'),
    },
  },
  {
    path: i18n.global.t('routes.register'),
    name: Routes.REGISTER,
    component: () => import('@/components/UserRegister.vue'),
    meta: {
      noAuthRequired: true,
      layout: 'clean',
      title: i18n.global.t('titles.register'),
    },
  },
  {
    path: i18n.global.t('routes.registerConfirm'),
    name: Routes.REGISTER_CONFIRM,
    component: () => import('@/components/UserRegisterConfirm.vue'),
    meta: {
      noAuthRequired: true,
      layout: 'clean',
      title: i18n.global.t('titles.registerConfirm'),
    },
  },
  {
    // T00NLZDOGNSQ — link from the coach signup mail; lives on the admin tenant
    // because the coach's own tenant does not exist before the confirmation.
    path: i18n.global.t('routes.coachSignupConfirm'),
    name: Routes.COACH_SIGNUP_CONFIRM,
    component: () => import('@/components/CoachSignupConfirm.vue'),
    meta: {
      noAuthRequired: true,
      layout: 'clean',
      title: i18n.global.t('titles.coachSignupConfirm'),
    },
  },
];
